export default "__VITE_ASSET__CxFb1Z0F__"